import * as React from 'react';
import CloseIcon from 'svg/CloseIcon';
import { Button } from 'components/Button';
import Modal from 'components/modals/Modal';

interface Props {
  isOpen: boolean;
  closeModal: (value: boolean) => void;
  title: string;
  description: string;
  buttonText?: string;
}

export default function ModalGroup({
  isOpen,
  closeModal,
  title,
  buttonText = 'Close',
  description,
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={() => closeModal(false)}
      classNameMaxWidth="md:max-w-[25rem] xs:max-w-md"
    >
      <div className="flex flex-col  justify-between gap-8 px-6 pb-5 pt-6">
        <div className="flex flex-row justify-between text-left">
          <h3 className="typography-product-heading-compact text-left text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {title}
          </h3>

          <button
            className="p-0.5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
            type="button"
            onClick={() => closeModal(false)}
          >
            <CloseIcon />
          </button>
        </div>
        <p className="typography-product-body font-normal	 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {description}
        </p>
        <div className="w-full">
          <Button variant="brand" className="w-full" size="lg" onClick={() => closeModal(false)}>
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
